import React from "react";
import styles from "./DuplicateRegistrationCertificate.module.css";

function PaymentDetails() {
  return (
    <div className={styles.hireRiderContainer}>
      <h2 className={styles.sectionTitle}>Payment Details</h2>
      
      <div className={styles.paymentGrid}>
        <div className={styles.paymentRow}>
          <span className={styles.feeTitle}>RTO Service Fee</span>
          <span className={styles.feeAmount}>₹2,600</span>
        </div>
        
        <div className={styles.paymentRow}>
          <span className={styles.feeTitle}>Convenience Fee</span>
          <span className={styles.feeAmount}>₹200</span>
        </div>
        
        <div className={styles.paymentRow}>
          <span className={styles.feeTitle}>GCT@18%</span>
          <span className={styles.feeAmount}>₹36</span>
        </div>
        
        <div className={styles.paymentRow}>
          <span className={styles.feeTitle}>Rider Fee</span>
          <span className={styles.feeAmount}>₹200</span>
        </div>
        
        <div className={`${styles.paymentRow} ${styles.totalRow}`}>
          <span className={styles.feeTitle}>Grand Total</span>
          <span className={styles.feeAmount}>₹3,036</span>
        </div>
      </div>
      
      {/* <button className={styles.payButton}>Pay ₹ 3,036</button> */}
    </div>
  );
}

export default PaymentDetails;